import { forwardRef, type ComponentPropsWithoutRef } from 'react';
import classNames from 'classnames';
import styles from './FJInput.module.less';

interface FJInputProps extends ComponentPropsWithoutRef<'input'> {
    maxLength?: number;
}

const FJInput = forwardRef<HTMLInputElement, FJInputProps>(function FJInput(
    { className, type = 'text', maxLength, ...rest },
    ref,
) {
    return (
        <input ref={ref} type={type} className={classNames(styles.root, className)} maxLength={maxLength} {...rest} />
    );
});

export default FJInput;
